module.exports = __webpack_public_path__ + "img/hk_bank.0176b71b.png";